module.exports = __webpack_public_path__ + "static/img/logo32.1939d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo32.png
// module id = MNwk
// module chunks = 1